import { useMemo } from 'react'
import moment from 'moment-timezone'

import {Box } from '@mui/material'

import {
  MRT_ToggleDensePaddingButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table'

import StudioTable, { useStudioTable } from '../studio-table'

const RequestHistoryTable = ({ threads, loading, selectThread}) => {

  const columns = useMemo(() => [
    {
      id: 'created_date',
      accessorFn: (originalRow) => moment(originalRow.created_date),
      header: 'Created',
      filterVariant: 'date-range',
      sortingFn: 'datetime',
      size: 200,
      Cell: ({ cell }) => cell.getValue().format("DD MMM YYYY HH:mm")
    },
    {
      accessorKey: 'subject',
      header: 'Subject',
      filterVariant: 'autocomplete',
      size: 800,
    },
    {
      accessorKey: 'status',
      header: 'Status',
      filterVariant: 'autocomplete',
      size: 800,
    },    
  ])

  const table = useStudioTable({
    tableKey: 'support',
    columns,
    data : threads,
    state : {
      isLoading : loading,
    },
    initialState: { showColumnFilters: false },
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableRowActions: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    positionToolbarAlertBanner: "none",
    getRowId: (originalRow) => originalRow.thread_id,

    muiTableBodyRowProps: ({ row }) => {
      const { status, thread_id: threadId } = row.original ?? {}
      const statusStyles =
        status === 'replied'
          ? { fontWeight: 700 }
          : status === 'closed'
            ? { color: 'text.disabled' }
            : null

      return {
        onClick: () => {
          if (threadId) {
            selectThread(threadId)
          }
        },
        sx: {
          cursor: 'pointer',
          ...(statusStyles ? { '& .MuiTableCell-root': statusStyles } : {}),
        },
      }
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <MRT_ToggleGlobalFilterButton table={table} />
        <MRT_ToggleFiltersButton table={table} />
        <MRT_ShowHideColumnsButton table={table} />
        <MRT_ToggleDensePaddingButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
      </Box>
    )
  })

  return (
  <div className='flex-1 min-h-0 flex flex-col h-full'>
    <StudioTable table={table} />
  </div>
  )
}

export default RequestHistoryTable
